import * as React from 'react'

import * as entities from '@owl-nest/entities'
import * as money from '@owl-nest/money'

import * as ds from '@bob/design-system'

export type ProductCardProps = {
  align?: 'none' | 'left' | 'right'
  product: entities.product.MediumProduct
}

export function ProductCard({ product, align = 'none' }: ProductCardProps): React.ReactElement {
  return (
    <ds.styles.wysiwyg.CardWrapper $float={align}>
      <ds.ProductCard
        brand={product.brand}
        compareAtPriceRange={
          product.compareAtPriceRange
            ? [money.format(product.compareAtPriceRange[0]), money.format(product.compareAtPriceRange[1])]
            : undefined
        }
        href={product.href}
        picture={product.picture}
        priceRange={
          product.priceRange ? [money.format(product.priceRange[0]), money.format(product.priceRange[1])] : undefined
        }
        title={product.title}
        compact={true}
      />
    </ds.styles.wysiwyg.CardWrapper>
  )
}
